<template>
  <div>
    <HeaderTop></HeaderTop>
    <div class="page-content" style="width: 1200px;margin: 100px auto 30px auto;">
      <p class="newMine_pageTitle">{{$route.query.type=='1'?'通知公告':'新闻政策'}}</p>
    <div class="newMine_content">
      <div class="content-title">
        <h3 class="title">{{ notices.title }}</h3>
        <div class="d-flex d-flex-center">
          <p class="name">作者：{{ notices.writer }}</p>
          <p class="name">发布时间：{{ notices.releaseDate }}</p>
          <p class="name">来源：{{ notices.source }}</p>
          <p class="time">访问人数：{{ notices.visitNum }}</p>
        </div>
      </div>
      <div class="content-explain">
        <div v-html="notices.content"></div>
      </div>
    </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { mapState } from "vuex"
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    HeaderTop,
    Footer
  },
  name: "newsDetails",
  data () {
    return {
      loading: false,
      notices: {}
    };
  },
  computed: {
    ...mapState(['user'])
  },
  created () {
    this.getData();
  },
  methods: {
    async getData () {
      this.$http.get('/student/pc/index/newDetail',{id:this.$route.query.id}).then(res=>{
        this.notices=res||{}
      })
    },
  },
};
</script>
<style lang="scss">
.content-explain {
  img{
    max-width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.newMine_content {
  padding: 0 30px;
}

.content-title {
  padding: 30px 0 0 0;
  margin-bottom: 30px;
  font-size: 16px;

  .title {
    font-weight: 400;
    color: #333333;
    text-align: center;
  }

  .name {
    font-weight: 400;
    margin-right: 30px;
  }

  .time {
    font-weight: 400;
  }
}

.content-explain {
  line-height: 35px;
  margin: 5px;
  img{
    max-width: 100%;
  }
}
</style>
